import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import Modal from 'js/components/modal';
import { Checkbox, SortableTable } from 'js/components/design-system';
import { getLpCodeColumns } from './functions';
import GeneralSearchInput from 'js/components/controls/general-search-input';
import { returnFilteredData } from './functions';
import EmptyState from 'js/components/controls/empty-state';

const ManageCodesModal = (props) => {
  const { t } = useTranslation();
  const [searchString, setSearchString] = useState('');
  const {
    title,
    active,
    mounted,
    onClose,
    onSave,
    legalProblemCodes = [],
    onChange,
    isCopy,
  } = props;

  const renderCheckboxForRow = (key, lpCode) => {
    return (
      <Checkbox
        checked={lpCode.selected}
        onChange={() => onChange(lpCode)}
        key={key}
      />
    );
  };

  const filteredLPC = returnFilteredData(legalProblemCodes, searchString);

  return (
    <Modal
      className="manage-codes-modal"
      cancelButtonText={t('components.DeactivateModal.closeButton')}
      onClickCancel={onClose}
      titleText={title}
      mounted={mounted}
      underlayClickExits={false}
      verticallyCenter
    >
      <h2>{title}</h2>
      <p>{t(`components.ReleasePage.manageLpCode.checkMessage`)}</p>
      <div className="table-container">
        <GeneralSearchInput
          placeholder={t('components.ReleasePage.searchPlaceholder')}
          onSearch={setSearchString}
          onReset={() => setSearchString('')}
          disabled={active}
        />
        <SortableTable
          columns={getLpCodeColumns(t, renderCheckboxForRow)}
          data={filteredLPC}
          initialSortColumnKey={'code'}
        />
        {filteredLPC.length === 0 && (
          <EmptyState
            title={t(`components.ReleasePage.manageLpCode.lpcEmpty`)}
          />
        )}
      </div>
      <div className="button-bar">
        <button
          className="button-link-appearance"
          onClick={onClose}
          disabled={active}
        >
          {t('components.ReleasePage.manageLpCode.cancelButton')}
        </button>
        <button
          className="button button-highlight"
          onClick={onSave}
          disabled={active || filteredLPC.length === 0}
        >
          {isCopy
            ? t('components.ReleasePage.manageLpCode.copyButton')
            : t('components.ReleasePage.manageLpCode.saveButton')}
        </button>
      </div>
    </Modal>
  );
};

ManageCodesModal.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string,
  mounted: PropTypes.bool,
  active: PropTypes.bool,
  onClose: PropTypes.func,
  onSave: PropTypes.func,
  onChange: PropTypes.func,
  legalProblemCodes: PropTypes.array,
  isCopy: PropTypes.bool,
};

export default ManageCodesModal;
